import React, { useEffect, useState } from 'react'
import { deliveryUserState } from '../../store/recoilData'
import { useRecoilState } from 'recoil'
import {
    Avatar, Button, Card, Divider, Drawer, Flex, List, Input,Select, 
    Breadcrumb, Skeleton,
    
} from 'antd'
import { useParams, useLocation, useOutletContext } from 'react-router-dom'
import LoginCtrl from './loginCtrl'
import { useToasts } from 'react-toast-notifications'
import {
    getPedidos, putCadastro, getEnderecos, 
    deleteEndereco, getFidelidade
} from '../../services/bd/cardapioDigital'
import { LeftOutlined, LogoutOutlined, RightOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'
import AVATAR from '../../img/avatar.png'
import { validaCelular, validateEmail } from '../../services/util'
import TelefoneBrasileiroInput from "react-telefone-brasileiro";
import { apiviacep } from '../../services/api.service'
import TROFEU from '../../img/trofeu.png'
import CALENDARIO from '../../img/calendar.png'
import SELO from '../../img/selo.png'
import { EnderecosCtrl } from './enderecosCtrl'

export const Perfil = (props) => {

    const [app, openAuth, setOpenAuth] = useOutletContext();
    const { addToast } = useToasts()
    const [userDelivery, setUserDelivery] = useRecoilState(deliveryUserState)
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)

    const [registro, setRegistro] = useState(JSON.parse(JSON.stringify(userDelivery ? userDelivery : {})))
    const [openCredenciais, setOpenCredecinais] = useState(false)

    const [openEnderecos, setOpenEnderecos] = useState(false)
    const [enderecos, setEnderecos] = useState([])

    const [openEndereco, setOpenEndereco] = useState(false)
    const [itemSelected, setItemSelected] = useState(undefined)

    const [openFidelidade, setOpenFidelidade] = useState(false)
    const [fidelidade, setFidelidade] = useState({
        historico: []
    })

    const [openMore, setOpenMore] = useState(false)

    const itens = [{
        nome: 'Credenciais',
        descricao: 'Atualize suas informações',
        icon: <RightOutlined />
    },
    {
        nome: 'Endereços de Entrega',
        descricao: 'Meus endereços de entrega',
        icon: <RightOutlined />
    },
    {
        nome: 'Programa de Fidelidade',
        descricao: 'Acumule pontos em seus pedidos',
        icon: <RightOutlined />
    },
    {
        nome: 'Sair',
        descricao: 'Deslogar do sistema',
        icon: <LogoutOutlined />
    }
    ]



    useEffect(() => {
        if (userDelivery) {
            loadPedidos()
            loadEnderecos()
            loadFidelidade()
        }
    }, [])


    async function loadEnderecos() {
        try {
            const resp = await getEnderecos(userDelivery?.token)
            setEnderecos(resp)
        } catch (error) {

        }
    }


    async function loadFidelidade() {
        try {
            const resp = await getFidelidade(userDelivery?.token)
            setFidelidade(resp)
        } catch (error) {
            addToast(error.message, { autoDismiss: true, appearance: 'error' })
        }
    }

    async function loadPedidos() {
        try {
            setLoading(true)
            const resp = await getPedidos(userDelivery?.token)
            setData(resp)
        } catch (error) {
            addToast(error.message, { autoDismiss: true, appearance: 'error' })
        }
        setLoading(false)
    }


    return userDelivery ? <Flex style={{ padding: 20 }} vertical>
        <Flex justify='center' style={{ marginTop: 15 }}>
            <Avatar src={AVATAR} shape='square' size={80} />
        </Flex>
        <Flex justify='center'>
            <h6> {userDelivery.name} </h6>
        </Flex>
        <List
            style={{ backgroundColor: 'white', marginTop: 15 }}
            bordered
            loading={loading}
            dataSource={itens}
            renderItem={(item, index) =>
            (
                <List.Item key={item.nome}
                    onClick={() => {
                        switch (index) {
                            case 0: setOpenCredecinais(true); break;
                            case 1: setOpenEnderecos(true); break;
                            case 2: setOpenFidelidade(true); break;
                            case 3: setUserDelivery(undefined); break;
                        }


                    }}>
                    <List.Item.Meta
                        title={item.nome}
                        description={item.descricao}
                    />
                    <div>{item.icon}</div>
                </List.Item>
            )
            }
        />


        <Drawer
            style={{ backgroundColor: 'whitesmoke' }}
            open={openCredenciais}
            width={'100%'}
            title={null}
            closable={false}>
            <Flex vertical gap={5}>
                <Flex align='center' gap={5}>
                    <LeftOutlined onClick={() => setOpenCredecinais(false)} />
                    <Flex justify='center' flex={1}>
                        <Breadcrumb items={[{ title: 'Perfil' }, { title: 'Credenciais' }]} />
                    </Flex>
                </Flex>
                <Divider style={{ marginTop: 5, marginBottom: 10 }} />
                <Flex style={{ padding: 15 }} vertical>
                    <Flex wrap style={{ color: '#313131ff', textAlign: 'center' }}>Mantenha seus dados atualizados para acompanhar seus pedidos e promoções.</Flex>
                </Flex>
                <Card bordered size='small'>
                    <Flex vertical>
                        <Flex style={{ marginTop: 20 }}>Nome</Flex>
                        <Input 
                        maxLength={150} 
                        value={registro.name} 
                        onChange={(e) => setRegistro({ ...registro, name: e.target.value })} />

                        <Flex style={{ marginTop: 5 }}>Celular</Flex>
                         <TelefoneBrasileiroInput
                            autocomplete="off"
                            autoComplete="off"
                            className={"ant-input css-dev-only-do-not-override-aya5jp ant-input-outlined"}
                            style={{
                                paddingLeft: 6, paddingTop: 6, paddingBottom: 6, autocomplete: "off", borderRadius: 5, borderWidth: 0.3,
                                BorderColor: 'ligthgray'
                            }}
                            value={ registro.phone}
                            onChange={(e) => {
                                setRegistro({ ...registro, phone: e.target.value })
                            }}
                            temDDD
                            separaNono={false}
                            separaDDD={true}
                        />


                        <Flex style={{ marginTop: 5 }}>E-mail</Flex>
                        <Input maxLength={150} value={registro.email} onChange={(e) => setRegistro({ ...registro, email: e.target.value })} />

                        <Button
                            block
                            loading={loading}
                            disabled={!validateEmail(registro.email) || registro.name.trim() === "" || !validaCelular(registro.phone)
                            }
                            type='primary'
                            style={{ backgroundColor: app.cor, marginTop: 30 }} onClick={async () => {
                                try {
                                    setLoading(true)
                                    await putCadastro(userDelivery?.token, registro)
                                    addToast("Dados atualizados com sucesso!", { appearance: 'success', autoDismiss: true })
                                    let _userDelivery = JSON.parse(JSON.stringify(userDelivery))
                                    _userDelivery.name = registro.nome
                                    _userDelivery.email = registro.email
                                    _userDelivery.phone = registro.phone
                                    setUserDelivery(_userDelivery)
                                    setOpenCredecinais(false)

                                } catch (error) {
                                    addToast(error.message, { appearance: 'error', autoDismiss: true })
                                }
                                setLoading(false)
                            }}> Salvar</Button>

                    </Flex>
                </Card>
            </Flex>
        </Drawer>

        {/*ENDEREÇOS */}
        {
            <Drawer
                style={{ backgroundColor: 'whitesmoke' }}
                open={openEnderecos}
                width={'100%'}
                title={null}
                closable={false}>
                <EnderecosCtrl setOpenEnderecos={setOpenEnderecos} showHeader={true} app={app}/>
            </Drawer>
        }

        

        {/* FIDELIDADE*/}
        {
            fidelidade && <Drawer
                open={openFidelidade}
                placement='left'
                onClose={() => setOpenFidelidade(false)}
                closable={false}
                title={null}>

                <Flex vertical gap={5}>
                    <Flex align='center' gap={5}>
                        <LeftOutlined onClick={() => setOpenFidelidade(false)} />
                        <Flex justify='center' flex={1}>
                            <Breadcrumb items={[{ title: 'Perfil' }, { title: 'Programa de Fidelidade' }]} />
                        </Flex>
                    </Flex>
                    <Divider style={{ marginTop: 5, marginBottom: 10 }} />

                    <Flex>
                        <Card bordered size='small' style={{ width: '100%' }}
                            title={<span style={{ fontWeight: 600, color: '#000' }}>
                                <img height={14} src={TROFEU} alt='trofeu' />
                                {" ".concat(fidelidade?.nome)}</span>}>
                            <Divider style={{ marginTop: 3, marginBottom: 3 }} />
                            <Flex justify='space-between' align='center'>
                                <Flex style={{ color: '#585757ff' }}>
                                    <span>Quando você atingir a pontuação de
                                        <span style={{ color: '#000', fontWeight: 600 }}> {fidelidade?.pontos} </span> pontos, poderá resgatar um desconto de
                                        <span style={{ color: '#000', fontWeight: 600 }}> R${fidelidade?.resgate} </span>
                                        para ser utilizado em um novo pedido.
                                    </span>
                                </Flex>
                            </Flex>
                            <Divider style={{ marginTop: 3, marginBottom: 3 }} />
                            <Flex align='center' justify='space-between'>
                                <Flex align='center' gap={4}>
                                    <img height={14} src={SELO} alt='historico' />
                                    Sua pontuação</Flex>
                                <Flex>{fidelidade?.saldo} / {fidelidade.pontos} pts</Flex>
                            </Flex>
                            <Divider style={{ marginTop: 3, marginBottom: 3 }} />
                            <Flex align='center' gap={4}>
                                <img height={14} src={CALENDARIO} alt='historico' />
                                Historico</Flex>
                            <List
                                bordered={false}
                                size='small'
                                dataSource={fidelidade?.historico}
                                renderItem={(item, index) => {
                                    return <List.Item
                                        actions={[<span style={{ color: '#000' }}>{"".concat(item.acumulado, 'pts')}</span>]}
                                    >
                                        <Skeleton avatar title={false} loading={loading} active>
                                            <List.Item.Meta
                                                avatar={<Flex>{item.pontos > 0 ? '+' : '-'}{item.pontos}pts</Flex>}
                                                title={item.descricao}
                                                description={dayjs(item.createAt).format('DD/MM/YYYY HH:mm')}
                                            />
                                            <div>Saldo</div>
                                        </Skeleton>
                                    </List.Item>
                                }} />

                        </Card>
                    </Flex>

                </Flex>

            </Drawer>

        }




    </Flex> : <LoginCtrl />
}


export default Perfil